import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { components } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import type { GroupOption } from '../../../common/types.tsx';
import messages from '../../../messages.tsx';

export type Props = {
	options: GroupOption[];
	children: ReactNode;
};

const MenuListComponent = (props: Props) => {
	const { options } = props;
	const { formatMessage } = useIntl();

	const footer =
		options.length > 0 && options[0].moreResultsAvailable ? (
			<MenuFooterText>{formatMessage(messages.menuFooter)}</MenuFooterText>
		) : null;
	return (
		// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; options: GroupOption[]; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 7 more.
		<components.MenuList {...props}>
			<Container>{formatMessage(messages.menuHeader)}</Container>
			{props.children}
			{footer}
		</components.MenuList>
	);
};

export default MenuListComponent;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const MenuFooterText = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtlest'),
	font: token('font.body'),
	paddingTop: token('space.100'),
	paddingRight: token('space.200'),
	paddingBottom: token('space.100'),
	paddingLeft: token('space.200'),
});

// eslint-disable-next-line @atlaskit/design-system/use-primitives, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	paddingTop: token('space.100'),
	paddingRight: token('space.200'),
	paddingBottom: token('space.100'),
	paddingLeft: token('space.200'),
});
